import * as yup from 'yup'

type Nullable<T> = { [P in keyof T]: T[P] | null }

export type LoginForm = {
  accountId: string
  password: string
}

export const LoginSchema = yup.object().shape<LoginForm>({
  accountId: yup.string().required(),
  password: yup.string().required()
})

export type EditExhibitorForm = {
  accountId: string
  password: string
  exhibition: string
  composition: string
  receptionId: string
  boothsCount: number
  country: string
  familyName: string
  familyNameEn: string
  givenName: string
  givenNameEn: string
  companyName: string
  companyNameEn: string
  companyNameKana: string
  department: string
  departmentEn: string
  position: string
  positionEn: string
  postalCode: string
  prefecture: string
  prefectureEn: string
  municipality: string
  municipalityEn: string
  address: string
  addressEn: string
  email: string
  tel: string
}

export const EditExhibitorSchema = yup.object().shape<EditExhibitorForm>({
  accountId: yup.string().required(),
  password: yup.string().required(),
  exhibition: yup.string().required(),
  composition: yup.string(),
  receptionId: yup.string(),
  boothsCount: yup.number(),
  country: yup.string(),
  familyName: yup.string(),
  familyNameEn: yup.string(),
  givenName: yup.string(),
  givenNameEn: yup.string(),
  companyName: yup.string(),
  companyNameEn: yup.string(),
  companyNameKana: yup.string(),
  department: yup.string(),
  departmentEn: yup.string(),
  position: yup.string(),
  positionEn: yup.string(),
  postalCode: yup.string(),
  prefecture: yup.string(),
  prefectureEn: yup.string(),
  municipality: yup.string(),
  municipalityEn: yup.string(),
  address: yup.string(),
  addressEn: yup.string(),
  email: yup.string().email(),
  tel: yup.string().required(),
})

export type EditBadgeForm = {
  displayName: string
  displayNameEn: string
  displayNameKana: string
  companyName: string
  companyNameEn: string
  companyNameKana: string
  department: string
  departmentEn: string
  position: string
  positionEn: string
  postalCode: string
  prefecture: string
  prefectureEn: string
  municipality: string
  municipalityEn: string
  address: string
  addressEn: string
  email: string
  tel: string
}

export const EditBadgeSchema = yup.object().shape<EditBadgeForm>({
  displayName: yup.string().required(),
  displayNameEn: yup.string(),
  displayNameKana: yup.string(),
  companyName: yup.string().required(),
  companyNameEn: yup.string(),
  companyNameKana: yup.string(),
  department: yup.string(),
  departmentEn: yup.string(),
  position: yup.string(),
  positionEn: yup.string(),
  postalCode: yup.string(),
  prefecture: yup.string(),
  prefectureEn: yup.string(),
  municipality: yup.string(),
  municipalityEn: yup.string(),
  address: yup.string(),
  addressEn: yup.string(),
  email: yup.string().email().required(),
  tel: yup.string().required(),
})

export type MailForm = {
  message: string
}

export const MailSchema = yup.object().shape<MailForm>({
  message: yup.string().required()
})